import { ChangeDetectionStrategy, Component, Inject, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DiagnosticCollectionDto, DiagnosticDto, DiagnosticLevel } from '../../../services/api.services';

@Component({
  selector: 'app-diagnostic-details-dialog',
  templateUrl: './diagnostic-details.dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DiagnosticDetailsDialogComponent {
  constructor(public dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any) { }
}

